import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-composition-wizard-screen',
    templateUrl: './composition-wizard-screen.component.html',
    styleUrls: ['./composition-wizard-screen.component.scss'],
    standalone: false
})
export class CompositionWizardScreenComponent implements OnInit {

  @Input() composition: Models.Composition;

  public availableLanguages = [
    {
      key: 'de',
      title: 'German',
      checked: false,
      disabled: false
    },
    {
      key: 'en',
      title: 'English',
      checked: false,
      disabled: false
    },
    {
      key: 'fr',
      title: 'French',
      checked: false,
      disabled: false
    },
    {
      key: 'it',
      title: 'Italian',
      checked: false,
      disabled: false
    }
  ];

  constructor() {
  }

  ngOnInit() {
    if (!this.composition.screen) {
      this.composition.screen = new Models.CompositionScreen();
      this.composition.screen.populateFromJSON({
        availableLanguages: null
      });
    }
    if (this.composition.screen.availableLanguages) {
      for (let i = 0; i < this.composition.screen.availableLanguages.length; i++) {
        const lang = this.composition.screen.availableLanguages[i];
        for (let j = 0; j < this.availableLanguages.length; j++) {
          if (this.availableLanguages[j].key === lang) {
            this.availableLanguages[j].checked = true;
          }
        }
      }
      if (this.composition.screen.disabledLanguages) {
        for (let i = 0; i < this.composition.screen.disabledLanguages.length; i++) {
          const lang = this.composition.screen.disabledLanguages[i];
          for (let j = 0; j < this.availableLanguages.length; j++) {
            if (this.availableLanguages[j].key === lang) {
              this.availableLanguages[j].disabled = true;
            }
          }
        }
      } else {
        this.composition.screen.disabledLanguages = [];
      }
    }
  }

  public assignLanguages(): void {
    const languages = [];
    for (let i = 0; i < this.availableLanguages.length; i++) {
      if (this.availableLanguages[i].checked) {
        languages.push(this.availableLanguages[i].key);
      } else {
        this.availableLanguages[i].disabled = false;
      }
    }
    this.composition.screen.availableLanguages = languages;
    this.disableLanguages();
    if (languages.length === 0) {
      this.composition.screen.availableLanguages = null;
    }
  }

  public disableLanguages(): void {
    const activatedLanguages = [];
    for (let i = 0; i < this.availableLanguages.length; i++) {
      if (this.availableLanguages[i].checked && this.availableLanguages[i].disabled) {
        activatedLanguages.push(this.availableLanguages[i].key);
      }
    }
    this.composition.screen.disabledLanguages = activatedLanguages;
  }

}
